module.exports = __webpack_public_path__ + "static/media/post1-template.98f22953.svg";